<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Адрес для переписки</div>
            <div class="dx-field-value">
                <ai-text-box-readonly :value="data?.kod_d_p" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';

const data = inject('data');
</script>
